import { gql } from 'apollo-angular';

export const CREATE_SUBSCRIPTION_CHECKOUT = gql`
  mutation CreateSubscriptionCheckout($planId: UUID!, $interval: SubscriptionInterval!) {
    createSubscriptionCheckout(planId: $planId, interval: $interval)
  }
`;

export const CREATE_CUSTOMER_PORTAL_SESSION = gql`
  mutation CreateCustomerPortalSession {
    createCustomerPortalSession
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription {
    cancelSubscription {
      id
      status
      cancelAtPeriodEnd
      currentPeriodEnd
    }
  }
`;

export const REACTIVATE_SUBSCRIPTION = gql`
  mutation ReactivateSubscription {
    reactivateSubscription {
      id
      status
      cancelAtPeriodEnd
    }
  }
`;

export const CHANGE_PLAN = gql`
  mutation ChangePlan($planId: UUID!, $interval: SubscriptionInterval!) {
    changePlan(planId: $planId, interval: $interval) {
      id
      status
      subscriptionPlanId
      stripePriceId
    }
  }
`;

// The account buys a booking pack for this month; billed with its next invoice.
export const PURCHASE_BOOKING_TOP_UP = gql`
  mutation PurchaseBookingTopUp($extraBookings: Int!) {
    purchaseBookingTopUp(extraBookings: $extraBookings) {
      id
      extraBookings
    }
  }
`;
